import React, { FC } from 'react';

import { currency } from '@pharmaplan/common';

import strings from '../../../../localization';
import PriceLabel from '../PriceLabel/PriceLabel';
import { IBillFooter } from '../types';

import styles from './style';

const BillFooter: FC<IBillFooter> = ({
  total,
  counterTotal,
  successAction,
  suffix,
}) => {
  let price = `${currency}${total}${suffix}`;
  let counterPrice = counterTotal && `$${counterTotal}`;

  if (counterTotal) {
    price = `${currency}${total}`;
    counterPrice = `${currency}${counterTotal}${suffix}`;
  }

  return (
    <PriceLabel
      successAction={successAction}
      title={strings.total}
      price={price}
      customStyle={styles.total}
      counterPrice={counterPrice}
    />
  );
};

export default BillFooter;
